import { render, staticRenderFns } from "./Grid1.vue?vue&type=template&id=ed088d88&scoped=true"
import script from "./Grid1.vue?vue&type=script&lang=ts"
export * from "./Grid1.vue?vue&type=script&lang=ts"
import style0 from "./Grid1.vue?vue&type=style&index=0&id=ed088d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed088d88",
  null
  
)

export default component.exports